import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GET_AI_AGENTS } from "../../api/aiKnowledge.service";
import { updateNodePayload } from "../../reducers/canvas/canvasSlice";
import { CustomButton } from "../CustomButton";
import StartNodeCheckMark from "../../view/Bots/components/start-node-checkmark";

const extractRows = (resp) => {
  if (Array.isArray(resp?.data)) return resp.data;
  if (Array.isArray(resp?.data?.data)) return resp.data.data;
  if (Array.isArray(resp?.data?.rows)) return resp.data.rows;
  if (Array.isArray(resp?.rows)) return resp.rows;
  return [];
};

const AIAgentInput = ({ onSave = () => {}, onCancel = () => {} }) => {
  const dispatch = useDispatch();
  const { selectedNode } = useSelector((state) => state.canvas);
  const [agents, setAgents] = useState([]);
  const [loadingAgents, setLoadingAgents] = useState(false);
  const [agentError, setAgentError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadAgents = async () => {
      setLoadingAgents(true);
      setAgentError("");
      try {
        const resp = await GET_AI_AGENTS();
        const rows = extractRows(resp);
        const mapped = rows
          .map((item) => ({
            id: String(item?.id || ""),
            name: String(item?.agentName || "").trim(),
          }))
          .filter((item) => item.id && item.name);

        if (!isMounted) return;
        setAgents(mapped);
      } catch (err) {
        if (!isMounted) return;
        setAgentError(err?.response?.data?.message || "Failed to load AI agents.");
      } finally {
        if (isMounted) setLoadingAgents(false);
      }
    };

    loadAgents();
    return () => {
      isMounted = false;
    };
  }, []);

  const handleAgentChange = (event) => {
    const nextAgentId = String(event.target.value || "");
    const nextAgent = agents.find((item) => item.id === nextAgentId);

    dispatch(
      updateNodePayload({
        selectedNodeId: selectedNode?.id,
        updatedData: {
          aiAgentId: nextAgentId,
          aiAgentName: nextAgent?.name || "",
          actions:
            selectedNode?.data?.actions?.length > 0
              ? selectedNode.data.actions
              : ["aiAgent"],
        },
      }),
    );
  };

  const handleSaveClick = () => {
    onSave();
  };

  return (
    <>
      <div className="card flex flex-column gap-2">
        <div className="font-semibold">AI Agent</div>
        <label htmlFor="ai-agent-dropdown" className="text-sm">
          Select AI Agent
        </label>
        <select
          id="ai-agent-dropdown"
          className="p-inputtext p-component w-full"
          value={String(selectedNode?.data?.aiAgentId || "")}
          onChange={handleAgentChange}
          disabled={loadingAgents}
        >
          <option value="">Select AI agent</option>
          {agents.map((agent) => (
            <option key={agent.id} value={agent.id}>
              {agent.name}
            </option>
          ))}
        </select>

        {loadingAgents ? (
          <div className="text-sm text-600">Loading AI agents...</div>
        ) : null}
        {agentError ? <div className="text-sm text-red-500">{agentError}</div> : null}
      </div>
      <StartNodeCheckMark />
      <div className=" mt-6 mb-3 flex justify-content-end gap-3 align-items-center">
        <CustomButton varient="outline" label={"Cancel"} onClick={onCancel} />
        <CustomButton varient="filled" label={"Save"} onClick={handleSaveClick} />
      </div>
    </>
  );
};

export default AIAgentInput;
